import {
    SHOW_ALL_REVIEW_START,
    SHOW_ALL_REVIEW_SUCCESS,
    SHOW_ALL_REVIEW_ERROR,
    AVERAGE_ALL_RATE_SUCCESS
  } from "Constant";

  const initialState = {
    loading: false,
    data:[],
    reviewAvgRate:0
  }

  export default function AllReviewReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case SHOW_ALL_REVIEW_START:
        return {
          ...state,
          loading: true,
        };
      case SHOW_ALL_REVIEW_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
        case AVERAGE_ALL_RATE_SUCCESS:
        return {
          ...state,
          reviewAvgRate: action.payload,
          loading: false,
        };
      case SHOW_ALL_REVIEW_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }